import challengesOH from '../optimhome/challenges';

export default {
  challenges: challengesOH,
};
